import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Modal } from '@bibliocommons/modal';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

/** @extends React.Component */
export class ModalContainer extends BcReactComponent {
  render () {
    const { modalKey, open, ...props } = this.props;
    return <Modal open={open} key={modalKey} {...props} />;
  }
}

ModalContainer.propTypes = {
  modalKey: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  open: ownProps.open || state.getIn(['ui', 'modal', ownProps.modalKey, 'open'], false)
});

export default connect(mapStateToProps)(ModalContainer);
